<template>
	<v-card>
		<v-card-title>
			<div><span class="headline">مدیریت برچسب ها</span></div>
			<v-spacer />
			<v-btn @click="close()" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<div v-if="loading">
				<v-progress-linear :size="4" color="primary" indeterminate />
			</div>
			<div v-else>
				<div v-if="!items.length">
					<h3 class="text-center red--text">لیست برچسب ها خالی است</h3>
					<div class="text-center mt-5">
						<v-btn class="mx-auto" color="green" dark @click="add">
							<v-icon dark>
								mdi-plus-circle-outline
							</v-icon>
							افزودن برچسب
						</v-btn>
					</div>
				</div>
				<div v-else>
					<v-card v-for="(item, index) in items" :key="item.id + index" class="mb-3" elevation="0" style="border: 1px solid #dca6e5">
						<div class="pa-2 d-flex align-center">
							<div style="flex-grow: 2;">
								<div class="grey--text" v-if="!item.editMode"><small>عنوان:</small></div>
								<div class="" v-if="!item.editMode">{{ item.title }}</div>
								<v-text-field class="pt-2" dense v-if="item.editMode" v-model="item.title" label="عنوان" :error-messages="errorMessages" :rules="[(val) => !!val || 'عنوان برچسب را وارد کنید']" required />
							</div>
							<div style="">
								<v-checkbox class="pt-2" dense :disabled="!item.editMode" v-model="item.isPublic" label="نمایش در صفحه اول" :error-messages="errorMessages" required />
							</div>
							<div>
								<v-btn v-if="!item.editMode" @click="edit(item)" class="ms-2 ml-1" x-small fab dark color="secondary" title="ویراش">
									<v-icon dark>
										mdi-square-edit-outline
									</v-icon>
								</v-btn>
								<v-btn v-if="!item.editMode" @click="remove(item, index)" class="ms-2 ml-1" x-small fab dark color="pink" title="حذف">
									<v-icon dark>
										mdi-trash-can-outline
									</v-icon>
								</v-btn>
								<v-btn :loading="submitLoading" @click="save(item, index)" class="ms-2 ml-1" title="ذخیره" v-if="item.editMode" color="success" fab x-small dark>
									<v-icon dark>
										mdi-check
									</v-icon>
								</v-btn>
								<v-btn class="ms-2 ml-1" @click="cancel(item, index)" v-if="item.editMode" title="انصراف" color="grey" fab x-small dark>
									<v-icon dark>
										mdi-close
									</v-icon>
								</v-btn>
							</div>
						</div>
					</v-card>
					<div class="text-center mt-5">
						<v-btn class="mx-auto" color="green" dark @click="add">
							<v-icon dark>
								mdi-plus-circle-outline
							</v-icon>
							افزودن برچسب جدید
						</v-btn>
					</div>
				</div>
			</div>
		</v-card-text>
		<confirm-dlg ref="confirm" />
	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import _ from 'lodash'

	export default {
		name: 'Tags',
		props: {
			data: { type: Object },
			category: { type: Number, default: 0 },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				emptyId: emptyId,
				errorMessages: '',
				items: [],
				submitLoading: false,
				loading: false,
				hasChange: false
			}
		},
		computed: {
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = false
				api.get('admin/Tag/List/' + this.category, null)
					.then(
						response => {
							this.items = response.map(x => {
								x.editMode = false
								return x
							})
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			edit(item) {
				item.editMode = true
				item.original = JSON.parse(JSON.stringify(item))
			},
			save(item, index) {
				if (!item.title) {
					toast.error('عنوان برچسب وارد نشده است.')
					return
				}
				this.submitLoading = true
				var clone = { ...item }
				api.post('admin/tag/' + (item.id === emptyId ? 'create' : 'edit'), clone)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						item.editMode = false
						this.loadData()
						this.hasChange = true
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			cancel(item, index) {
				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}
				item.name = item.original?.name
				item.editMode = false
			},
			async remove(item, index) {
				if (!item) {
					return
				}

				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/tag/delete/' + item.id)
						.then(response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadData()
							this.hasChange = true
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			add() {
				let newItem = {
					id: emptyId,
					title: '',
					tagCategory: 0,
					isPublic: true,
					editMode: true,
				}
				this.items.push(newItem)
			},
			close() {
				this.$emit('close')
				if (this.hasChange)
					this.$emit('callbck')
			}
		},
	}
</script>
<style></style>
